import { Button, Card, CardContent, Stack, Typography, useTheme } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import analytics from "../util/analytics";
import { useAuth } from "../util/auth";
import ProBadge from "./icons/ProBadge";

export default function UpgradeBanner(props) {
  const theme = useTheme();
  const auth = useAuth();

  if (auth.user && auth.user.isActiveSubscription) {
    return null;
  }

  return (
    <Card
      variant="outlined"
      sx={{
        backgroundColor: "rgba(87, 78, 235, 0.08)",
        color: theme.palette.grey[800],
        fontSize: 14,
      }}
    >
      <CardContent>
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="flex-start"
        >
          <ProBadge color={theme.palette.primary.main} />
          <Typography variant="h4" color="primary">
            Pro Unlimited
          </Typography>
        </Stack>
        <Typography sx={{ mt: 2 }}>
          <strong>Get unlimited access</strong> to all AI features:
        </Typography>

        <ul style={{ paddingLeft: 20 }}>
          <li>AI tattoo generator</li>
          <li>Templates by placement (sleeves, body parts, etc)</li>
          <li>Control tattoo complexity, colors, line weight, etc</li>
          <li>Image-to-stencil converter</li>
          <li>4x super resolution download</li>
          <li>Unlock all 4 images while browsing</li>
        </ul>

        <Button
          component={Link}
          to="/pricing"
          onClick={() => {
            analytics.track("cta-click", {
              context: props.context,
              action: "upgrade",
              title: "pro_unlimited",
              button_text: "upgrade_now",
            });
          }}
          variant="outlined"
          color="primary"
          fullWidth
        >
          Upgrade Now
        </Button>
      </CardContent>
    </Card>
  );
}
